module.exports = __webpack_public_path__ + "assets/MyMatrix_Logo_weiss.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/MyMatrix_Logo_weiss.png
// module id = ./src/public/images/MyMatrix_Logo_weiss.png
// module chunks = 0